import React from "react";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export default () => (
    <SkeletonTheme color={process.env.REACT_APP_SKELETON_COLOR} highlightColor={process.env.REACT_APP_SKELETON_HIHGLIGHTS_COLOR}>
        <Skeleton height={64} />
    </SkeletonTheme>
);
